export default {
	id: "220",
	title: "220",
	company: "Nokia",
	// borderRadius: "0.1em",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["12.5%", "12%", "44%", "12%"],
			colors: [
				{
					title: "White",
					hex: "#ffffff",
					img: require("./original/white.png")
				},
				{
					title: "Black",
					hex: "#000000",
					img: require("./original/black.png")
				},
				{title: "Blue", hex: "#02A0D6", img: require("./original/blue.png")},
				{title: "Red", hex: "#FF6053", img: require("./original/red.png")},
				{
					title: "Yellow",
					hex: "#F3F358",
					img: require("./original/yellow.png")
				}
			]
		}
	]
};
